// extracted by mini-css-extract-plugin
export var infoSection = "_m-1";
export var infoSectionContainer = "_m-0";
export var infoSectionTitleRow = "_m-2";
export var multiLineInfo = "_m-4";
export var strong = "_m-3";